<template>
  <div>
    <div class="table-tools">
      <h2 class="page-title" style="margin-bottom:0;">社团管理</h2>
      <el-button type="primary" @click="openCreate">新建社团</el-button>
    </div>

    <div class="card-panel" style="padding:20px;">
      <el-table :data="circles" width="100%">
        <el-table-column prop="name" label="社团名称" />
        <el-table-column label="负责人" min-width="180">
          <template slot-scope="scope">
            <span>{{ ownerText(scope.row.owner) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactMethod" label="联系方式" />
        <el-table-column prop="homepageUrl" label="主页" min-width="180" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'info'">{{ scope.row.isActive ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="180" />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="editCircle(scope.row)">编辑</el-button>
            <el-button type="text" style="color:#f56c6c;" @click="removeCircle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="form.id ? '编辑社团' : '新建社团'" :visible.sync="showDialog" width="560px">
      <el-form :model="form" label-position="top">
        <el-form-item label="社团名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form.ownerVendorId" filterable placeholder="请选择负责人供应商">
            <el-option v-for="vendor in activeVendors" :key="vendor.id" :label="ownerText(vendor)" :value="vendor.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="form.contactMethod" />
        </el-form-item>
        <el-form-item label="社团主页">
          <el-input v-model="form.homepageUrl" />
        </el-form-item>
        <el-form-item label="简介">
          <el-input v-model="form.description" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.isActive" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createCircle, deleteCircle, getCircles, getVendors, updateCircle } from '../../api/admin'

const defaultForm = () => ({
  id: null,
  name: '',
  ownerVendorId: null,
  contactMethod: '',
  homepageUrl: '',
  description: '',
  isActive: true,
})

export default {
  data() {
    return {
      circles: [],
      vendors: [],
      form: defaultForm(),
      showDialog: false,
    }
  },
  computed: {
    activeVendors() {
      return this.vendors.filter(vendor => vendor.isActive)
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const [circles, vendors] = await Promise.all([getCircles(), getVendors()])
      this.circles = circles.data
      this.vendors = vendors.data
    },
    ownerText(owner) {
      if (!owner) return '-'
      return `${owner.name}（${owner.shortCode || owner.vendorCode}）`
    },
    openCreate() {
      this.form = defaultForm()
      this.showDialog = true
    },
    editCircle(row) {
      this.form = { ...defaultForm(), ...row }
      this.showDialog = true
    },
    async submit() {
      try {
        if (this.form.id) {
          await updateCircle(this.form.id, this.form)
          this.$message.success('社团已更新')
        } else {
          await createCircle(this.form)
          this.$message.success('社团已创建')
        }
        this.showDialog = false
        this.loadData()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '保存失败')
      }
    },
    async removeCircle(row) {
      try {
        await this.$confirm(`确认删除社团 ${row.name}？`, '提示', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
        })
        await deleteCircle(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.response?.data?.message || '删除失败')
      }
    },
  },
}
</script>
